import React, { useEffect, useState } from "react";
import { getListDistrict } from "src/apis/ADB/district.api";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { notContainsOnlySpaces, validationADBWardInput } from "src/utils";

const initialValue = {
  id: "",
  wardName: "",
  wardCode: 0,
  districtId: "",
};

function WardForm(props) {
  const { addOrEdit, recordForEdit, provinceId } = props;

  // list province
  const [listDistrict, setListDistrict] = useState([]);

  // validation input permission
  const validateADBWardForm = (fieldValues = values) => {
    let temp = validationADBWardInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateADBWardForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateADBWardForm()) {
      addOrEdit(values, resetForm);
    }
  };

  useEffect(() => {
    getListDistrict({ provinceId }, (result) => {
      setListDistrict([...result]);
    });
  }, [provinceId]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="wardName"
        value={values.wardName}
        label="Ward Name"
        type="text"
        onChange={handleInputChange}
        error={errors.wardName}
      />
      <Controls.Input
        name="wardCode"
        value={values.wardCode}
        label="Ward Code"
        type="number"
        disabled={Boolean(recordForEdit)}
        onChange={handleInputChange}
        error={errors.wardCode}
      />

      <Controls.AdministrativeSelect
        name="districtId"
        label="District"
        value={values.districtId}
        onChange={handleInputChange}
        options={listDistrict}
        optionField={{ key: "id", value: "districtName" }}
        error={errors.districtId}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={notContainsOnlySpaces(values.wardName) ? false : true}
      />
    </Form>
  );
}

export default WardForm;
